// extracted by mini-css-extract-plugin
export default {"highMargin":"ContactUs_highMargin__lGZqL","smallMargin":"ContactUs_smallMargin__Vnrsh","tinyMargin":"ContactUs_tinyMargin__mS0cH"};